/*
  Pouch & Spark — bundle card gallery.
  Turns the "Cards in this lot/bundle" thumbnail strip (.pv-bthumbs, stored in the
  product description) into a responsive card grid + full-screen viewer with
  prev/next, swipe (mobile), arrow keys and Esc (desktop). No data changes needed:
  every bundle that has the strip gets the gallery.
*/
(function () {
  if (window.__pvBundleGallery) return;
  window.__pvBundleGallery = true;

  // Ask Shopify's CDN for a specific width; leave other hosts untouched.
  // cdn.shopify.com/s/files/<shop path>/... is served from Shopify's US origin (~650ms
  // per image from PH); the same file via the store's own /cdn/shop/ path goes through
  // the Cloudflare edge (Singapore/Manila cache, ~120ms) and reuses the page's connection.
  function sized(src, w) {
    src = src.replace(/^(?:https?:)?\/\/cdn\.shopify\.com\/s\/files\/\d+\/\d+\/\d+\/\d+\//, '/cdn/shop/');
    if (!/cdn\.shopify\.com|\/cdn\/shop\//.test(src)) return src;
    return src.replace(/([?&])width=\d+&?/, '$1').replace(/[?&]$/, '') + (src.indexOf('?') > -1 ? '&' : '?') + 'width=' + w;
  }
  function split(title) {
    var set = (title.match(/\[([^\]]+)\]\s*$/) || [])[1] || '';
    var name = title.replace(/\s*\[[^\]]*\]\s*$/, ''); // only the LAST [..] is the set
    return { name: name || title, set: set };
  }

  var cards = [], box, imgEl, capEl, setEl, countEl, idx = 0, lastFocus = null;

  function buildViewer() {
    if (box) return;
    box = document.createElement('div');
    box.className = 'pv-gbox';
    box.setAttribute('role', 'dialog');
    box.setAttribute('aria-modal', 'true');
    box.setAttribute('aria-label', 'Card viewer');
    box.innerHTML =
      '<button type="button" class="pv-gbox__close" aria-label="Close">&times;</button>' +
      '<button type="button" class="pv-gbox__nav pv-gbox__prev" aria-label="Previous card">&#8249;</button>' +
      '<figure class="pv-gbox__fig"><img class="pv-gbox__img" alt=""><figcaption class="pv-gbox__cap">' +
      '<span class="pv-gbox__name"></span><span class="pv-gbox__set"></span><span class="pv-gbox__count"></span></figcaption></figure>' +
      '<button type="button" class="pv-gbox__nav pv-gbox__next" aria-label="Next card">&#8250;</button>';
    document.body.appendChild(box);
    imgEl = box.querySelector('.pv-gbox__img');
    capEl = box.querySelector('.pv-gbox__name');
    setEl = box.querySelector('.pv-gbox__set');
    countEl = box.querySelector('.pv-gbox__count');
    box.querySelector('.pv-gbox__close').addEventListener('click', close);
    box.querySelector('.pv-gbox__prev').addEventListener('click', function (e) { e.stopPropagation(); go(-1); });
    box.querySelector('.pv-gbox__next').addEventListener('click', function (e) { e.stopPropagation(); go(1); });
    box.addEventListener('click', function (e) { if (e.target === box || e.target.classList.contains('pv-gbox__fig')) close(); });
    // swipe
    var x0 = null, y0 = null;
    box.addEventListener('touchstart', function (e) { var t = e.touches[0]; x0 = t.clientX; y0 = t.clientY; }, { passive: true });
    box.addEventListener('touchend', function (e) {
      if (x0 === null) return;
      var t = e.changedTouches[0], dx = t.clientX - x0, dy = t.clientY - y0;
      if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) go(dx < 0 ? 1 : -1);
      else if (dy > 90 && Math.abs(dy) > Math.abs(dx)) close(); // swipe down to close
      x0 = y0 = null;
    }, { passive: true });
    document.addEventListener('keydown', function (e) {
      if (!box.classList.contains('is-open')) return;
      if (e.key === 'Escape') close();
      else if (e.key === 'ArrowRight') go(1);
      else if (e.key === 'ArrowLeft') go(-1);
    });
  }

  function show(i) {
    idx = (i + cards.length) % cards.length;
    var c = cards[idx];
    imgEl.src = sized(c.src, 900);
    imgEl.alt = c.title;
    capEl.textContent = c.name;
    setEl.textContent = c.set;
    countEl.textContent = (idx + 1) + ' / ' + cards.length;
    // preload neighbours for smooth swiping
    [idx + 1, idx - 1].forEach(function (n) { var p = cards[(n + cards.length) % cards.length]; if (p) (new Image()).src = sized(p.src, 900); });
    var single = cards.length < 2;
    box.querySelector('.pv-gbox__prev').hidden = single;
    box.querySelector('.pv-gbox__next').hidden = single;
  }
  function go(d) { show(idx + d); }
  function open(i) {
    buildViewer();
    lastFocus = document.activeElement;
    show(i);
    box.classList.add('is-open');
    document.documentElement.classList.add('pv-gbox-lock');
    box.querySelector('.pv-gbox__close').focus({ preventScroll: true });
  }
  function close() {
    if (!box) return;
    box.classList.remove('is-open');
    document.documentElement.classList.remove('pv-gbox-lock');
    if (lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
  }

  function enhance(strip) {
    if (strip.dataset.pvGallery) return;
    strip.dataset.pvGallery = '1';
    var imgs = Array.prototype.slice.call(strip.querySelectorAll('img'));
    if (!imgs.length) return;
    var start = cards.length;
    var grid = document.createElement('div');
    grid.className = 'pv-gallery';
    imgs.forEach(function (im, k) {
      var title = im.getAttribute('title') || im.getAttribute('alt') || '';
      var parts = split(title);
      var src = im.getAttribute('src');
      cards.push({ src: src, title: title, name: parts.name, set: parts.set });
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'pv-gallery__item';
      b.setAttribute('aria-label', 'View ' + title);
      b.innerHTML = '<span class="pv-gallery__frame"><img loading="lazy" decoding="async" alt=""></span>' +
        '<span class="pv-gallery__name"></span><span class="pv-gallery__set"></span>';
      var gi = b.querySelector('img');
      gi.src = sized(src, 360);
      gi.srcset = sized(src, 240) + ' 240w, ' + sized(src, 360) + ' 360w, ' + sized(src, 480) + ' 480w';
      gi.sizes = '(max-width: 480px) 31vw, (max-width: 990px) 22vw, 160px';
      gi.alt = title;
      b.querySelector('.pv-gallery__name').textContent = parts.name;
      b.querySelector('.pv-gallery__set').textContent = parts.set;
      b.addEventListener('click', function () { open(start + k); });
      grid.appendChild(b);
    });
    strip.parentNode.insertBefore(grid, strip);
    strip.hidden = true;
    // "Cards in this lot" heading → add the count
    var prev = grid.previousElementSibling;
    if (prev && /cards in this/i.test(prev.textContent) && !/\(\d+\)/.test(prev.textContent)) {
      var strong = prev.querySelector('strong') || prev;
      strong.textContent = strong.textContent.replace(/\s*$/, '') + ' (' + imgs.length + ')';
      prev.classList.add('pv-gallery__heading');
    }
  }

  function init() { document.querySelectorAll('.pv-bthumbs').forEach(enhance); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
